import { Type } from 'class-transformer';
import { User } from './user';

export class Author {
  @Type(() => User)
  user: User;

  order: number;
}
